import $axios from "../api/accessor";
import { $api } from "../api/api";

export const SubscribersService = {
  async getAllSubscribers() {
    let response = await $axios.get($api("subscribes")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },

  async deleteSubscriber(id: string | number) {
    const response = await $axios.delete($api("subscribes_id", { id }));
    return response.data;
  },
};

